import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_DOCUMENT_MANAGEMENT_CLIENT_CONFIG =
  "GET_DOCUMENT_MANAGEMENT_CLIENT_CONFIG";

export const service = async (data) => {
  const options: object = {
    url: "/Api/User/GetDocumentManagementClientConfig",
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_DOCUMENT_MANAGEMENT_CLIENT_CONFIG, service, mock);
